import React, { Component } from "react";
import { Redirect, Link } from 'react-router-dom';
import ReactFullpage from '@fullpage/react-fullpage';
import styles from '../../assets/scss/modules/kampany.module.scss';
import twitter from "../../assets/media/images/Twitter.png";
import tiktok from "../../assets/media/images/Tiktok.png";
import instagram from "../../assets/media/images/Instagram.png";
import facebook from "../../assets/media/images/Facebook.png";
import jogasz from "../../assets/media/images/jogasz.png";
import kepviselo from "../../assets/media/images/kepviselo.png";
import csalad from "../../assets/media/images/csalad.png";
import asset1 from "../../assets/media/images/asset1.png";
import asset2 from "../../assets/media/images/asset2.png";
import asset3 from "../../assets/media/images/asset3.png";
import asset4 from "../../assets/media/images/asset4.png";
import program1 from "../../assets/media/images/Titles/mindannyiunkHangja.png";
import program2 from "../../assets/media/images/Titles/azOktatasEsMunkaVilaga.png";
import program3 from "../../assets/media/images/Titles/aKozegeszsegugyMeggyogyitasa.png";
import program4 from "../../assets/media/images/Titles/lakhatasLakasfenntartas.png";
import program5 from "../../assets/media/images/Titles/kornyezetunkMegovasa.png";
import program6 from "../../assets/media/images/Titles/epitettEsTermeszetiOrokseg.png";
import program7 from "../../assets/media/images/Titles/aKozlekedesiAnomaliakFeloldasa.png";
import program8 from "../../assets/media/images/Titles/aPenzugyiForrasokrol.png";
import program9 from "../../assets/media/images/Titles/meltoIdoskort.png";
import asset6 from "../../assets/media/images/asset6.png";
import back_btn from "../../assets/media/newicons/back.png";
import back_btn_inverz from "../../assets/media/newicons/back_darkMode.png";
import back_btn_black from "../../assets/media/newicons/back-black.png";
import forward_btn_black from "../../assets/media/newicons/nextBlue.png";
import forward_btn from "../../assets/media/newicons/forward.png";
import forward_btn_inverz from "../../assets/media/newicons/next_darkMode.png";
import erikfoto from "../../assets/media/images/Erik-foto.png";
import konczer_facebook from "../../assets/media/images/konczer-facebook.png";
import gradiensProgram from "../../assets/media/images/gradiensProgram.png";
import Footer from "../Footer/Footer";
import FooterResponziv from "../Footer/FooterResponziv";
import NavbarComponent from "../../NavbarComponent";



import{
	MDBContainer,
  MDBScrollbar,
	MDBRow,
	MDBCol,
	MDBCard,
	MDBCardHeader,
	MDBCardBody,
  MDBBtn,
} from 'mdbreact';

class BackComponent extends Component {

  render() {
    return (
      <div className="navbar-component">
        <MDBRow center className="m-0 pl-4 pt-4">
            <MDBCol middle md="1" className="text-right pl-0 pr-3">
              <MDBRow end className="m-0 p-0">
                <Link to="/#program" className="inline-block"><img className="back-btn" src={back_btn}></img></Link>
              </MDBRow>
            </MDBCol>
            <MDBCol middle md="4" className="text-left p-0">
              <MDBRow start className="m-0">
                <Link to="/#program" className="inline-block"><span className="back-text text-capitalize">Programok</span></Link>
              </MDBRow>
            </MDBCol>
            <MDBCol middle md="6" className="text-right p-0">
            <MDBRow end className="m-0">
              <span className="kovetkezo text-capitalize">Következő</span>
            </MDBRow>
            <MDBRow end className="m-0">
              <Link to={"/" + this.props.text} className="inline-block"><span className="back-text text-capitalize">{this.props.text2}</span></Link>
            </MDBRow>
            </MDBCol>
            <MDBCol middle md="1" className="text-left pr-0 pl-3">
            <MDBRow start className="m-0">
              <Link to={"/" + this.props.text} className="inline-block"><img className="back-btn" src={forward_btn}></img></Link>
            </MDBRow>
            </MDBCol>
        </MDBRow>
				<img className="gradiensProgram-kampany" src={gradiensProgram}></img>
        <img className="asset5" src={this.props.program == "program1" ? program1 : this.props.program == "program2" ? program2 : this.props.program == "program3" ? program3 :
			this.props.program == "program4" ? program4 : this.props.program == "program5" ? program5 : this.props.program == "program6" ? program6 : this.props.program == "program7" ? program7 :
		this.props.program == "program8" ? program8 : this.props.program == "program9" ? program9:false}></img>
      </div>
    );
  }
}
export default  BackComponent;
